<!-- 用户功能 - 重置密码父组件 -->

<template>
	<div class="Reset">
		<h3 class="title" style="width: 100%;text-align: center;">找回密码</h3>
		<div class="content">
			<router-view></router-view>
		</div>
		<p class="_line"></p>
	</div>

</template>
<script>
	export default{
		data () {
			return {

			}
		},
		created () {
			this.$store.commit('setCurrentHeader', 'feedback');
		}
	}
</script>
<style>
	body,html,h3,ul,li,p{
		margin:0;
		padding:0;
	}
	li{
		list-style: none;
	}
	.content{
		/*border-top: solid 1px #ccc;*/
		/*border-bottom: solid 1px #ccc;*/
		height: 535px;
	}
	.Reset{
		width: 1202px;
		margin: 0 auto;
	}
	.Reset > .title {
		font-size: 16px;
		font-weight: normal;
		padding-left: 5px;
		padding-bottom: 15px;
		border-bottom: solid 1px #ccc;
	}
	._line{
		padding-bottom: 30px;
		border-top: solid 1px #ccc;
	}
</style>



// WEBPACK FOOTER //
// Reset.vue?e4968cb0